module.exports = __webpack_public_path__ + "static/media/ic_launcher.5ef2fb24.png";